import React, { useState } from "react";
import { FlaskConical, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { api } from "../../lib/api";
import { apiErr } from "../../lib/apiErr";

export default function TestSendButton() {
  const [busy, setBusy] = useState(false);
  const send = async () => {
    setBusy(true);
    try {
      const r = await api.post("/push/test");
      const n = r.data?.sent ?? 0;
      if (n > 0) toast.success(`Notifikasi uji terkirim ke ${n} perangkat akun Anda`);
      else toast.warning("Tidak ada perangkat terdaftar di akun admin ini — login ke aplikasi Oryntix (izinkan notifikasi) lalu coba lagi");
    } catch (e) { toast.error(apiErr(e, "Gagal mengirim notifikasi uji")); } finally { setBusy(false); }
  };
  return (
    <button onClick={send} disabled={busy} title="Hanya ke perangkat akun Anda sendiri — tidak ke pengguna lain" className="flex items-center gap-1.5 rounded-xl border border-brand/30 bg-brand/5 px-4 py-2 text-xs font-bold text-brand disabled:opacity-50" data-testid="ann-test-send">
      {busy ? <Loader2 size={13} className="animate-spin" /> : <FlaskConical size={13} />} Uji ke akun saya
    </button>
  );
}
